import { z } from 'zod';

export const InputSchema = z.object({
    oddsFormat: z.enum(['decimal', 'fractional']),
});

export type ChangeOddsFormatInput = z.infer<typeof InputSchema>;
